import TableAPI from 'app/components/TableAPI'
import React from 'react'
import { View } from 'styles/reactnative'
import { CurrencyColumns } from './CurrencyColumns'
import { Button, message } from 'antd'
import API from 'utils/api'
import { useToken } from 'app/hooks'


const CurrencySetting = ({ title, type }: any) => {
	const { data: token } = useToken()
	return (
		<View style={{ width: '100%' }}>
			<Button
				onClick={() => {
					API.post('/admin/currencyrefresh', token + '', {}).then((res=>{
						message.success('갱신완료')
					}))
				}}>
				환율갱신
			</Button>

			<TableAPI
				title={title}
				columns={CurrencyColumns}
				usermodal={false}
				height={'default'}
				loadingshow={false}
				groupsearch={false}
				width={1350}
				autorefresh={false}
				apikey={'/admin/currency?t='}
			/>
		</View>
	)
}

export default React.memo(CurrencySetting)
